var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { completeInspection, fetchInspectionDetail } from '../../../http/inspections';
import { navigate } from '../../../utility/general';
import Button from '../../components/button';
import CModal from '../../components/modal';
import InspectionContent, { countByResult } from '../../components/inspection-content';
import Layout from './layout';
export default (props) => {
    const [detail, setDetail] = React.useState(null);
    const [confirmSkipped, setConfirmSkipped] = React.useState(null);
    React.useEffect(() => {
        fetchInspectionDetail(props.inspectionId, {
            'success': (data) => setDetail(data),
            'error': () => setDetail(null),
        });
    }, [props.inspectionId]);
    if (!detail) {
        return _jsx(Layout, { title: "Loading...", exitTo: props.onExit, children: _jsx("p", { className: "text-muted", children: "Loading..." }) });
    }
    const skipped = countByResult(detail).skipped;
    const finalize = (finish) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield completeInspection(props.inspectionId, {
                'success': () => {
                    setConfirmSkipped(null);
                    navigate('#/inspection-mode/my-jobs');
                },
                'error': () => { },
            });
        }
        finally {
            finish();
        }
    });
    const onCompleteClick = () => {
        if (skipped > 0) {
            setConfirmSkipped(skipped);
        }
        else {
            finalize(() => { });
        }
    };
    return _jsxs(_Fragment, { children: [_jsxs(Layout, { title: "Review", exitTo: props.onExit, children: [_jsx(InspectionContent, { detail: detail }), _jsxs("div", { className: "d-grid gap-2", children: [_jsx(Button, { color: "success", w100: true, onClick: onCompleteClick, children: "Complete Inspection" }), _jsx(Button, { color: "secondary", w100: true, onClick: () => navigate(`#/inspection-mode/${props.inspectionId}`), children: "Back to Sections" })] })] }), _jsx(CModal, { visible: confirmSkipped !== null, title: "Items Not Inspected", onClose: () => setConfirmSkipped(null), onSubmit: (f) => finalize(f), action: "Complete Anyway", sm: true, children: confirmSkipped !== null && (_jsxs("p", { children: [confirmSkipped, " item", confirmSkipped === 1 ? '' : 's', " ", confirmSkipped === 1 ? 'is' : 'are', " still marked \"Not inspected.\" Complete anyway?"] })) })] });
};
